app.validators = {
    blocked_method           : {
        checks: {
            alwaysFalse: {
                msgKey : 'always_false'
            }
        }
    },
	cc_name_on_card          : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 40,
				msgKey : 'maxlength'
			},
			validateCardHolderName : {
				msgKey : 'invalid_cardholder_name'
			}
		}
	},
	first_name          : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 50,
				msgKey : 'maxlength'
			}
		}
	},
	last_name          : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 50,
				msgKey : 'maxlength'
			}
		}
	},
	cc_cvv2                  : {
		checks : {
			testCVV2 : {
				msgKey : 'exact_digits',
				unknownCCMsgKey : 'enter_cvv'
			},
			// testCVV2ContainsOnlyZeroes: {
			// 	msgKey: 'invalid_cvv'
			// }
		}
	},
	visa_checkout_cc_cvv2   : {
		checks : {
			testCVV2 : {
				msgKey : 'exact_digits',
				unknownCCMsgKey : 'enter_cvv'
			},
			// testCVV2ContainsOnlyZeroes: {
			// 	msgKey: 'invalid_cvv'
			// }
		}
	},
	cc_card_number           : {
		checks : {
			asyncCheck:{
				fn: function(v, p){return app.util.asyncCheck.getCardErrorMsg(v);},
				restricted_bothBrandsMsgKey: 'restricted_bothBrands'
				// /* * add "msgKey"s to overwrite Srv Response Text * */
				// ,restricted_cardTypeMsgKey        : "restricted_card_type"
				// ,restricted_cardProductMsgKey     : "restricted_card_type"
				// ,restricted_issuerCountryMsgKey   : "restricted_card_issuer_country"
				// ,restricted_userCountryMsgKey     : "restricted_card_user_country"
			},
			cc_minlength     : {
				min    : 8,
				msgKey : 'invalid_creditcard'
			},
			cc_maxlength     : {
				max    : 19,
				msgKey : 'maxlength'
			},
			creditcard       : {
				msgKey : 'invalid_creditcard'
			},
			isCardAcceptable : {
				msgKey : 'invalid_creditcard',
				restrictedCCMsgKey : 'restricted_card_type',
				restrictedCCCurrencyMsgKey    : 'restricted_card_currency',
				allowedCCMsgKey    : 'allowed_card_type',
				restrictedCCCountryMsg: 'card_country_not_allowed'
			}
		}
	},
	cc_card_number_upo_ro : {
		checks : {
			isCurrencySupportedByTheCard: {
				restrictedCCCurrencyMsgKey    : 'restricted_card_currency'
			}
		}
	},
	cc_partial_card_number           : {
		checks : {
			cc_minlength     : {
				min    : 8,
				msgKey : 'invalid_creditcard'
			},
			cc_maxlength     : {
				max    : 19,
				msgKey : 'maxlength'
			},
			creditcard       : {
				msgKey : 'invalid_creditcard'
			},
			isCardAcceptable : {
				msgKey : 'invalid_creditcard',
				restrictedCCMsgKey : 'restricted_card_type',
				restrictedCCCurrencyMsgKey    : 'restricted_card_currency',
				allowedCCMsgKey    : 'allowed_card_type'
			}
		}
	},
	abon_voucherNumber: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			testRegex: {
				regex: /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/,
				msgKey: 'invalid_voucher_number'
			}
		}
	},
	abon_userPhone: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			maxlength: {
				max: 15,
				msgKey: 'maxlength'
			}
		}
	},
	abon_terms: {
		checks : {
			isChecked: {
				selector: '#abon_terms',
				msgKey: 'unconfirmed_agreement'
			}
		}
	},
	ach_terms: {
		checks : {
			isChecked: {
				selector: '#ach_terms',
				msgKey: 'unconfirmed_agreement'
			}
		}
	},
	airbank_bankCode: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 4,
				msgKey: 'exact_digits'
			}
		}
	},
	airbank_accountNumber: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 10,
				msgKey: 'exact_digits'
			}
		}
	},
	airbank_accountPrefix: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 6,
				msgKey: 'exact_digits'
			}
		}
	},
	astro_pay_prepaid_cc_card_number           : {
		checks : {
			cc_minlength     : {
				min    : 16,
				msgKey : 'invalid_creditcard'
			},
			cc_maxlength     : {
				max    : 16,
				msgKey : 'maxlength'
			},
			creditcard       : {
				msgKey : 'invalid_creditcard'
			},
			isCardAcceptable : {
				msgKey : 'invalid_creditcard',
				restrictedCCMsgKey : 'restricted_card_type',
				restrictedCCCurrencyMsgKey    : 'restricted_card_currency',
				allowedCCMsgKey    : 'allowed_card_type'
			}
		}
	},
	astro_pay_prepaidBF_cc_card_number  : {
		checks : {
			cc_minlength     : {
				min    : 16,
				msgKey : 'invalid_creditcard'
			},
			cc_maxlength     : {
				max    : 16,
				msgKey : 'maxlength'
			},
			creditcard       : {
				msgKey : 'invalid_creditcard'
			},
			isCardAcceptable : {
				msgKey : 'invalid_creditcard',
				restrictedCCMsgKey : 'restricted_card_type',
				restrictedCCCurrencyMsgKey    : 'restricted_card_currency',
				allowedCCMsgKey    : 'allowed_card_type'
			}
		}
	},
	astro_pay_prepaid_cc_cvv2           : {
		checks : {
			exactlength : {
				len    : 4,
				msgKey : 'enter_astropay_cvv'
			},
			digitsOnly  : {
				msgKey : 'enter_astropay_cvv'
			},
			// testCVV2ContainsOnlyZeroes: {
			// 	msgKey: 'invalid_cvv'
			// }
		}
	},
	astro_pay_prepaidBF_cc_cvv2           : {
		checks : {
			exactlength : {
				len    : 4,
				msgKey : 'enter_astropay_cvv'
			},
			digitsOnly  : {
				msgKey : 'enter_astropay_cvv'
			},
			// testCVV2ContainsOnlyZeroes: {
			// 	msgKey: 'invalid_cvv'
			// }
		}
	},
	astro_pay_prepaidBF_email_or_phone: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testAstroPayPrepaidAccountId: {
				msgKey: 'invalid_astro_pay_prepaid_account_id'
			}
		}
	},
	bacs_bank_id: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	bacs_account_number: {
		checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
		}
	},
	bacs_sort_code: {
		checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 6,
                msgKey: "exact_digits"
            }
        }
	},
	bacs_terms: {
		checks : {
			isChecked: {
				selector: '#bacs_terms',
				msgKey: 'unconfirmed_agreement'
			}
		}
	},
	bankTransfer_bank_id: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	bankTransfer_iban: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testIBAN: {
				msgKey: 'invalid_iban'
			}
		}
	},
	bankTransfer_account_number: {
		checks: {
            notEmpty: {
                msgKey: 'required_field'
            }
		}
	},
	bankTransfer_sort_code: {
		checks: {
            notEmpty: {
                msgKey: 'required_field'
            },
            digitsOnly: {
                msgKey: 'digits_only'
            },
            exactlength: {
                len: 6,
                msgKey: "exact_digits"
            }
        }
	},
	bankTransfer_terms: {
		checks : {
			isChecked: {
				selector: '#bankTransfer_terms',
				msgKey: 'unconfirmed_agreement'
			}
		}
	},
	bankaCreditas_bankCode: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 4,
				msgKey: 'exact_digits'
			}
		}
	},
	bankaCreditas_accountNumber: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 10,
				msgKey: 'exact_digits'
			}
		}
	},
	bankaCreditas_accountPrefix: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 6,
				msgKey: 'exact_digits'
			}
		}
	},
	classic_ach_account_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			maxlength: {
				max: 17,
				msgKey: 'maxlength'
			}
		}
	},
	classic_ach_routing_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 9,
				msgKey: 'exact_digits'
			}
		}
	},
	daviplata_fiscalNumber: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	instantOb_bankId: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_bank: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_name: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_city: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_address: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_country: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	lean_iban: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testIBAN: {
				msgKey: 'invalid_iban'
			}
		}
	},
	konbini_store: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	nequi_phone_number: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength: {
				len: 10,
				msgKey: 'exact_digits'
			}
		}
	},
	nettelerSecureId         : {
		checks : {
			exactlength : {
				len    : 6,
				msgKey : 'netteler_secure_id_validation'
			},
			digitsOnly  : {
				msgKey : 'netteler_secure_id_validation'
			}
		}
	},
	nettelerAccount          : {
		checks : {
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	item_amount_1            : {
		checks : {
			notEmpty           : {
				msgKey : 'required_field'
			},
			nonZeroNumberStart : {
				msgKey : 'open_amount_format'
			},
			maxFractionLength : {
				"apmgw_Octopus": {"HKD": 1},
				msgKey : 'max_fraction_length'
			},
			inRange            : {
				min    : 0,
				max    : 1250,
				minMsgKey : 'not_in_range_open_amount_under_min',
				maxMsgKey : 'not_in_range_open_amount_above_max',
				msgKey    : 'not_in_range_open_amount'
			},
			exceedsCreditCardDepositLimit : {
				msgKey : 'exceeds_credit_card_limit'
			},
			testPlayPlusBalance : {
				msgKey                    : 'insufficient_funds_playplus',
				notEnrolledMsgKey         : 'you_need_to_enroll_deposit'
			},
			testOktoCashDecimalAmount : {
				msgKey: 'no_decimal_values_allowed'
			}
		}
	},
	expiration_period        : {
		checks : {
			cc_expiration : {
				msgKey : 'invalid_expiration_date'
			}
		}
	},
	qiwi_phonenumber         : {
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			maxlength : {
				max    : 15,
				msgKey : 'maxlength'
			}
		}
	},
	muchBetter_mobilePhone         : {
		checks : {
			testCompositePhone  : {
				msgKey : 'invalid_phone_number'
			},
			maxlength : {
				max    : 18,
				msgKey : 'maxlength'
			}
		}
	},
    mbWay_mobilePhone 		 : {
        checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			testRegex: {
				regex: /^[0-9]*\-?[0-9]*$/,
				msgKey : 'digits_only'
			},
			exactlength: {
				len: 13,
				msgKey: 'mbway_phone_length'
			},
            testMbwayPhoneNumber  : {
                msgKey : 'invalid_phone_number'
            },
        }
	},
	mercado_phone_number: {
		checks : {
			testCompositePhone: {
				msgKey: 'invalid_phone_number'
			}
		}
	},
	mobi_accountType: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
		}
	},
	mobi_bankCodeRetail: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
		}
	},
	mobi_bankCodeCorporate: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
		}
	},
	moneta_payment_password  : {
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 5,
				msgKey : 'exact_digits'
			}
		}
	},
	moneta_account_id        : {
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 8,
				msgKey : 'exact_digits'
			}
		}
	},
	netbankingtw_ssn: {
		checks: {
			exactlength: {
				len: 10,
				msgKey: 'exact_characters'
			},
			testRegex: {
				regex: /^[a-zA-Z0-9-]{10}$/,
				msgKey : 'invalid_ssn'
			}
		}
	},
	ob_account_number: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			}
		}
	},
	ob_bank_id: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	ob_iban             : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testIBAN: {
				msgKey: 'invalid_iban'
			}
		}
	},
	ob_sort_code: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 6,
				msgKey : 'exact_digits'
			}
		}
	},
	ob_terms: {
		checks : {
			isChecked: {
				selector: '#ob_terms',
				msgKey: 'unconfirmed_agreement'
			}
		}
	},
	oktocash_terms: {
		checks: {
			isChecked: {
				selector: '#oktocash_terms',
				msgKey : 'unconfirmed_privacy_policy'
			}
		}
	},
	oktocash_termsOfUse: {
		checks: {
			isChecked: {
				selector: '#oktocash_termsOfUse',
				msgKey : 'unconfirmed_agreement'
			}
		}
	},
	oktowallet_email : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	oktowallet_terms: {
		checks: {
			isChecked: {
				selector: '#oktowallet_terms',
				msgKey : 'unconfirmed_agreement'
			}
		}
	},
	onShopMobilePhone: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testRegex: {
				regex: /^39-3[0-9]{8,9}$/,
				msgKey: 'invalid_phone_number'
			}
		}
	},
	oxxo_personal_id: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	oxxoPayPersonalId: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	pay4funId : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	payretailers_personalId: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	payto_payment_type: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	payto_account_name: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	payto_account_number: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	payto_bsb: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testRegex: {
				regex: /^[0-9]{3}-[0-9]{3}$/,
				msgKey : 'invalid_bsb'
			}
		}
	},
	payto_pay_id: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			},
			validatePayToPayId: {
				controlSelector: 'input[name="payto_pay_id_type"]:checked',
				invalidEmailMsgKey: 'invalid_email',
				msgKey: 'invalid_payto_phonenumber'
			}
		}
	},
	payto_pay_id_type: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	paytm_ssn: {
		checks: {
			exactlength: {
				len: 10,
				msgKey: 'exact_characters'
			},
			testRegex: {
				regex: /^[a-zA-Z0-9-]{10}$/,
				msgKey : 'invalid_ssn'
			}
		}
	},
	pix_personal_id: {
        checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
    },
	pix_of_bank_name: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	pix_of_personal_id: {
        checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength: {
				len: 11,
				msgKey: 'exact_digits'
			},
			testBrazilPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
    },
	ecoPayz_account_id       : {
		checks : {
			digitsOnly : {
				msgKey : 'digits_only'
			},
			inRange    : {
				min    : 1000000000,
				max    : 2147483647,
				msgKey : 'not_in_range_account_id'
			}
		}
	},
	webanq_account_id        : {
		checks : {
			testWBAccountId : {
				msgKey : 'not_in_range_account_id'
			}
		}
	},
	webanq_account_password  : {
		checks : {
			testWBAccountPassword : {
				msgKey : 'invalid_password' // add MSG
			}
		}
	},
	webanq_password  : {
		checks : {
			testWBAccountPassword : {
				msgKey : 'invalid_password'
			}
		}
	},
	toditocash_card_number   : {
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 10,
				msgKey : 'exact_digits'
			}
		}
	},
	toditocash_pin_code      : {
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 4,
				msgKey : 'exact_digits'
			}
		}
	},
	upi_ssn: {
		checks: {
			exactlength: {
				len: 10,
				msgKey: 'exact_characters'
			},
			testRegex: {
				regex: /^[a-zA-Z0-9-]{10}$/,
				msgKey : 'invalid_ssn'
			}
		}
	},
	wd_pay_safe_first_name   : {
		checks : {
			notEmpty        : {
				msgKey : 'required_field'
			},
			testPaySafeName : {
				msgKey : 'invalid_first_name' // "field.validation.invalid_first_name"
			}
		}
	},
	wd_pay_safe_last_name    : {
		checks : {
			notEmpty        : {
				msgKey : 'required_field'
			},
			testPaySafeName : {
				msgKey : 'invalid_last_name' // "field.validation.invalid_last_name"
			}
		}
	},
	wd_pay_safe_birthdate    : { // PaySafe // issue PPPWDR-365 (YYYY-MM-DD)
		checks : {
			notEmpty             : {
				msgKey : 'required_field'
			},
			testPaySafeBirthdate : {
				msgKey : 'invalid_birthdate' // add MSG "field.validation.invalid_birthdate"
			}
		}
	},
	wd_pay_safe_account_id   : { // PaySafe // issue PPPWDR-365 email
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email' // "field.validation.invalid_email"
			}
		}
	},
	payer_name    : {
		checks : {
			notEmpty        : {
				msgKey : 'required_field'
			}
		}
	},
	payer_email   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email' // "field.validation.invalid_email"
			}
		}
	},
	citadel_holder_name      : {     // PPPVFIVE-2245  /^.{1,50}$/
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 50,
				msgKey : 'maxlength'
			}
		}
	},
	citadel_iban             : {    // PPPVFIVE-2245  /^.{1,31}$/
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 31,
				msgKey : 'maxlength'
			}
		}
	},
	citadel_swift_code       : { // PPPVFIVE-2245 /^[A-Za-z]{6}[A-Za-z0-9]{2,5}$/
		checks : {
			testCitadelSwiftCode : {
				msgKey : 'invalid_swift_code'
			}
		}
	},
	citadel_bank_city        : { // PPPVFIVE-2245 /^.{1,30}$/
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 30,
				msgKey : 'maxlength'
			}
		}
	},
	citadel_bank_name        : { // PPPVFIVE-2245 /^.{1,40}$/
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength : {
				max    : 40,
				msgKey : 'maxlength'
			}
		}
	},
	citadel_account_numberCA : { // PPPVFIVE-2245 /^[0-9]{5,12}$/
		checks : {
			notEmpty   : {
				msgKey : 'required_field'
			},
			digitsOnly : {
				msgKey : 'digits_only'
			},
			minlength  : {
				min    : 5,
				msgKey : 'minlength'
			},
			maxlength  : {
				max    : 12,
				msgKey : 'maxlength'
			}
		}
	},
	citadel_account_numberAU : { // PPPVFIVE-2245 /^[0-9]{5,9}$/
		checks : {
			notEmpty   : {
				msgKey : 'required_field'
			},
			digitsOnly : {
				msgKey : 'digits_only'
			},
			minlength  : {
				min    : 5,
				msgKey : 'minlength'
			},
			maxlength  : {
				max    : 9,
				msgKey : 'maxlength'
			}
		}
	},
	citadel_branch_codeCA    : { // PPPVFIVE-2245 /^[0-9]{5}$/
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 5,
				msgKey : 'exact_digits'
			}
		}
	},
	citadel_bank_codeCA      : { // PPPVFIVE-2245 /^[0-9]{3}$/
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 3,
				msgKey : 'exact_digits'
			}
		}
	},
	citadel_branch_codeAU    : { // PPPVFIVE-2245  /^[0-9]{6}$/
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 6,
				msgKey : 'exact_digits'
			}
		}
	},
	citadel_ibanMX           : { // PPPVFIVE-2245 /^[0-9]{18}$/
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 18,
				msgKey : 'exact_digits'
			}
		}
	},
	iDebit_account_id        : { // CASH-374
		checks : {
			notEmpty                : {
				msgKey : 'required_field'
			},
			testInstadebitAccountId : {
				msgKey : 'invalid_idebit_account_id'
			},
			maxlength               : {
				max    : 30,
				msgKey : 'maxlength'
			}
		}
	},
	promoCode                : { // CASH-603
		checks : {
			testPromoCode : {
				msgKey : 'invalid_promo_code'
			}
		}
	},
	country                  : {
		checks : {
			notEmpty : {
				msgKey : 'required_field'
			}
		}
	},
	city                     : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			minlength : {
				min    : 2,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 50,
				msgKey : 'maxlength'
			}
		}
	},
	zip                      : {
		checks : {
			testZip : {
				msgKey : 'invalid_zip'
			}
		}
	},
	dateOfBirth 			 : {
		checks : {
			testDateOfBirth : {
				msgKey : 'invalid_date_of_birth'
			}
		}
	},
	address1                 : {
		checks : {
			notEmpty    : {
				msgKey : 'required_field'
			},
			minlength   : {
				min    : 2,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 60,
				msgKey : 'maxlength'
			},
			testAddress : {
				msgKey : 'invalid_address'
			}
		}
	},
	address2                 : {
		checks : {
			notEmpty    : {
				msgKey : 'required_field'
			},
			minlength   : {
				min    : 2,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 60,
				msgKey : 'maxlength'
			},
			testAddress : {
				msgKey : 'invalid_address'
			}
		}
	},
	webmoney_id                : {
		checks : {
			exactlength : {
                len    : 12,
                msgKey : 'exact_digits'
            },
			digitsOnly  : {
				msgKey : 'digits_only'
			}
		}
	},
	webmoney_sms_code  : {
		checks : {
			minlength   : {
				min    : 1,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 64,
				msgKey : 'maxlength'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			}
		}
	},
	webmoney_sms_code_lightbox  : {
		checks : {
			minlength   : {
				min    : 1,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 64,
				msgKey : 'maxlength'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			}
		}
	},
	wd_mb_email  : { // BF-424
		checks : {
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	israeli_card_holder_id  : { // BACKLOG-211
		checks : {
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			minlength  : {
				min    : 4,
				msgKey : 'minlength'
			},
			maxlength  : {
				max    : 9,
				msgKey : 'maxlength'
			},
			testIsraeliCardHolderID  : {
				msgKey : 'invalid_israeli_card_holder_id'
			}
		}
	},
	phone1  : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength  : {
				max    : 18,
				msgKey : 'maxlength'
			},
			testPhonenumber  : {
				msgKey : 'invalid_phone_number'
			}
		}
	},
	phone2  : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength  : {
				max    : 18,
				msgKey : 'maxlength'
			},
			testPhonenumber  : {
				msgKey : 'invalid_phone_number'
			}
		}
	},
	phone3  : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			maxlength  : {
				max    : 18,
				msgKey : 'maxlength'
			},
			testPhonenumber  : {
				msgKey : 'invalid_phone_number'
			}
		}
	},
	phone4  : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			digitsOnly  : {
				msgKey : 'invalid_phone_number'
			},
			minlength  : {
				min    : 10,
				msgKey : 'minlength'
			},
			maxlength  : {
				max    : 11,
				msgKey : 'maxlength'
			}
		}
	},
	email : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	state: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	confirmEmail: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	confirm_bankAccount: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			custom: {
				fn: function (v, p) {
					return v && v.trim() === $('#usr_bankAccount').val().trim();
				},
				msgKey : 'invalid_confirm_account'
			}
		}
	},
	houseNumber: {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	ticket_premium_account_id        : { 
		checks : {
			testTicketPremiumAccountId : {
				msgKey : 'not_in_range_account_id'
			}
		}
	},
	county        : {
		checks : {
			maxlength               : {
				max    : 255,
				msgKey : 'maxlength'
			}
		}
	},
	shippingCounty : {
		checks : {
			maxlength               : {
				max    : 255,
				msgKey : 'maxlength'
			}
		}
	},
	personal_id : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	efecty_personal_id: {
        checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
    },
	iban             : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testIBAN: {
				msgKey: 'invalid_iban'
			}
		}
	},
	verification_email : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	fonix_phonenumber : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testRegex: {
				regex: /^44-0?7[0-9]{9}$/,
				msgKey: 'invalid_fonix_phone'
			}
		}
	},
	vr_code : {
		checks: {
			notEmpty : {
				msgKey: 'required_field'
			},
			exactlength : {
				len    : 6,
				msgKey : 'exact_digits'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			}
		}
	},
    molpay_buyer_name : {
		checks: {
			notEmpty : {
				msgKey: 'required_field'
			}
		}
	},
    molpay_buyer_email : {
		checks: {
			notEmpty : {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
    molpay_buyer_mobile : {
		checks: {
			notEmpty : {
				msgKey: 'required_field'
			},
			testPhonenumber  : {
				msgKey : 'invalid_phone_number'
			}
		}
	},
	ftnPrefix : {
		checks: {
			digitsOnlyOrEmpty  : {
				msgKey : 'digits_only'
			},
			maxlength : {
				max    : 6,
				msgKey : 'maxlength'
			},
			fortunaMod11ChechBanks : {
				msgKey: 'invalid_prefix_number_msg'
			}
		}
	},
	ftnAccountNumber : {
		checks: {
			notEmpty : {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			atLeastTwoNonZeroDigits: {
				msgKey: 'invalid_account_number'
			},
			minlength     : {
				min    : 2,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 10,
				msgKey : 'maxlength'
			},
			fortunaMod11ChechBanks : {
				msgKey: 'invalid_account_number_msg'
			}
		}
	},
	ftnBankCode: {
		checks: {
			notEmpty : {
				msgKey: 'required_field'
			}
		}
	},
	giropay_bic: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testBic : {
				msgKey: 'invalid_bic'
			}
		}
	},
	interac_eTransfer_email: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	interac_eTransfer_mobilePhone: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testPhonenumber  : {
				msgKey : 'invalid_phone_number'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 10, // 10 <=> 1234567890 | 12 <=> 123-456-7890 (our BE expects: 1234567890)
				msgKey : 'exact_digits'
			}
		}
	},
	interac_Combined_email: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	interac_Combined_mobilePhone: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testPhonenumber  : {
				msgKey : 'invalid_phone_number'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength : {
				len    : 10, // 10 <=> 1234567890 | 12 <=> 123-456-7890 (our BE expects: 1234567890)
				msgKey : 'exact_digits'
			}
		}
	},
	interac_instant_email: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	interac_deposit_flow_type: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	jtBanka_bankCode: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 4,
				msgKey: 'exact_digits'
			}
		}
	},
	jtBanka_accountNumber: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 10,
				msgKey: 'exact_digits'
			}
		}
	},
	jtBanka_accountPrefix: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength: {
				len: 6,
				msgKey: 'exact_digits'
			}
		}
	},
	rebilling_terms_checkbox: {
		checks: {
			isChecked: {
				selector: '#rebilling_terms_checkbox',
				msgKey: 'unconfirmed_agreement'
			}
		}
	},
	ownAccount: {
		checks: {
			isChecked: {
				selector: '#ownAccount',
				msgKey: 'unconfirmed_owner'
			}
		}
	},
	prepaidCards_card_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength : {
				len    : 10,
				msgKey : 'exact_digits'
			}
		}
	},
	transaction_bank_id: {
		checks: {
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength : {
				len    : 4,
				msgKey : 'exact_digits'
			}
		}
	},
	echeck_dateOfBirth : {
		checks : {
			testDateOfBirth : {
				msgKey : 'invalid_date_of_birth'
			}
		}
	},
	echeck_city        : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			minlength : {
				min    : 2,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 50,
				msgKey : 'maxlength'
			}
		}
	},
	echeck_country     : {
		checks : {
			notEmpty          : {
				msgKey : 'required_field'
			},
			testEcheckCountry : {
				msgKey : 'echeck_invalid_country'
			}
		}
	},
	echeck_state       : {
		checks : {
			notEmpty        : {
				msgKey : 'required_field'
			},
			testEcheckState : {
				msgKey : 'echeck_invalid_state'
			}
		}
	},
	echeck_zip         : {
		checks : {
			testEcheckZip : {
				msgKey : 'echeck_invalid_zip'
			}
		}
	},
	echeck_address     : {
		checks : {
			notEmpty    : {
				msgKey : 'required_field'
			},
			minlength   : {
				min    : 2,
				msgKey : 'minlength'
			},
			maxlength   : {
				max    : 60,
				msgKey : 'maxlength'
			},
			testAddress : {
				msgKey : 'invalid_address'
			}
		}
	},
	echeck_phoneNumber : {
		checks : {
			notEmpty        : {
				msgKey : 'required_field'
			},
			exactlength   : {
				len    : 10,
				msgKey : 'invalid_phone_number'
			},
			testPhonenumber : {
				msgKey : 'invalid_phone_number'
			}
		}
	},
	echeck_account_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			maxlength : {
				max    : 12,
				msgKey : 'exact_digits'
			}
		}
	},
	echeck_aba_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength : {
				len    : 8,
				msgKey : 'exact_digits'
			}
		}
	},
	echeck_ssn: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly: {
				msgKey: 'digits_only'
			},
			exactlength : {
				len    : 4,
				msgKey : 'exact_digits'
			}
		}
	},
	echeck_account_type : {
		checks : {
			notEmpty : {
				msgKey : 'required_field'
			}
		}
	},
	echeck_firstName    : {
		checks : {
			notEmpty : {
				msgKey : 'required_field'
			}
		}
	},
	echeck_lastName     : {
		checks : {
			notEmpty : {
				msgKey : 'required_field'
			}
		}
	},
	blik_code     : {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			custom: {
				fn: function (v, p) {
					v = (v || "").trim();
					var isValid = /^[0-9]{3} [0-9]{3}$/.test(v);

					if (!isValid && p && p.message) {
						p.message = p.message.replace('{0}', p.len);
					}

					return isValid;
				},
				msgKey : 'exact_digits',
				len: 6
			}
		}
	},
	fortumo_phone_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			maxlength: {
				max: 20,
				msgKey: 'maxlength'
			}
		}
	},
	pay4fun_account_email: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	paymentasia_email: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	paymentasia_phone: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	postFinancePayDirectFlow: {
		checks: {
			testPostFinancePayDirectFlow: {
				fldName: 'postFinancePayDirectFlow',
				msgKey: 'checkbox_direct_flow_eligible'
			}
		}
	},
	rupay_ssn: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testRegex: {
				regex: /^[a-zA-Z0-9-]{10}$/,
				msgKey: 'invalid_ssn'
			}
		}
	},
	safetyPay_personalId: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	saltarpay_firstName   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	saltarpay_lastName   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	saltarpay_email   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	saltarpay_address   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	saltarpay_city   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	saltarpay_postcode   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	saltarpay_dateOfBirth   : {
		checks : {
			testDateOfBirth : {
				msgKey : 'invalid_date_of_birth'
			}
		}
	},
	saltarpay_country   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	sencillito_personal_id: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	smart2pay_personalId: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			}
		}
	},
	smart2pay_phone: {
		checks: {
			testSmart2PayPhonenumber: {
				msgKey : 'invalid_phone_number'
			}
		}
	},
	smart2pay_phone_number: {
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testRegex: {
				regex: /^[0-9+-/.() \\]{1,15}$/,
				msgKey : 'invalid_phone_number'
			}
		}
	},
	spei_personal_id: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	paymentez_userName   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	paymentez_fiscalNumber : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},

			minlength   : {
				min    : 6,
				msgKey : 'minlength'
			},
			maxlength : {
				max    : 11,
				msgKey : 'maxlength'
			}
		}
	},
	sightline_ssn : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength   : {
				len    : 4,
				msgKey : 'exact_digits'
			}
		}
	},
	netbanking_bankCode   : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			}
		}
	},
	elementpay_userPhone: {
		checks : {
			notEmpty  : {
				msgKey: 'required_field'
			},
			testPhonenumber: {
				msgKey : 'invalid_phone_number'
			},
			minlength : {
				min    : 5,
				msgKey : "minlength"
			},
			maxlength : {
				max    : 15,
				msgKey : 'maxlength'
			},
			testRegex: {
				regex: /^(.*?\d){5,}.*$/,
				msgKey : 'invalid_phone_number'
			}
		}
	},
	elementpay_accountNumber: {
		checks : {
			notEmpty  : {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			minlength : {
				min    : 5,
				msgKey : "minlength"
			},
			maxlength : {
				max    : 19,
				msgKey : 'maxlength'
			}
		}
	},
	elementpay_nid: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			maxlength : {
				max    : 16,
				msgKey : 'maxlength'
			}
		}
	},
	elementpay_accountType: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
		}
	},
	elementpay_bankId: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
		}
	},
	easypay_email: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEmail : {
				msgKey : 'invalid_email'
			}
		}
	},
	mazooma_dob: { // apmgw_eCheckSelect_DOB (YYYY-MM-DD)
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testDateOfBirth: {
				msgKey: 'invalid_date_of_birth'
			}
		}
	},
	mazooma_state: { // apmgw_eCheckSelect_DOB
		checks: {
			notEmpty: {
				msgKey: 'required_field'
			},
			testEcheckState: {
				msgKey: 'echeck_invalid_state'
			}
		}
	},
	webpay_personal_id : {
		checks : {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	},
	bancomatPay_mobileNumber : {
        checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			testCompositePhone  : {
                msgKey : 'invalid_phone_number'
            },
			testRegex: {
				regex: /^[0-9]*\-?[0-9]*$/,
				msgKey : 'digits_only'
			},
			maxlength : {
				max    : 20,
				msgKey : 'maxlength'
			},
        }
	},
	codi_phone_number: {
		checks : {
			notEmpty: {
				msgKey: 'required_field'
			},
			digitsOnly  : {
				msgKey : 'digits_only'
			},
			exactlength   : {
				len    : 10,
				msgKey : 'invalid_phone_number'
			}
		}
	},
	yape_personalId: {
		checks: {
			notEmpty  : {
				msgKey : 'required_field'
			},
			testPersonalId : {
				msgKey : 'invalid_personal_id'
			}
		}
	}
};
